import { render, staticRenderFns } from "./ProductCardListView.vue?vue&type=template&id=f5c0d272&"
import script from "./ProductCardListView.vue?vue&type=script&lang=js&"
export * from "./ProductCardListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports